import { render, staticRenderFns } from "./VisitorsPage.vue?vue&type=template&id=50c8b1ce&scoped=true&"
import script from "./VisitorsPage.vue?vue&type=script&lang=js&"
export * from "./VisitorsPage.vue?vue&type=script&lang=js&"
import style0 from "./VisitorsPage.vue?vue&type=style&index=0&id=50c8b1ce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8b1ce",
  null
  
)

export default component.exports